/* eslint-disable import/prefer-default-export */
import React from "react";
import { FORM_BUILDER_FIELD_TYPE, LabelText } from "@loanbossinc/component-library";

import {
  shouldShowTerm,
  shouldShowPercent,
  shouldShowOpenPeriod,
  shouldShowAggregateInterestMethodId,
  shouldShowAggregateInterestDefinedAmt,
  shouldShowAggregateInterestMonthsOfInterest,
  shouldShowForYmYmaMw,
  shouldShowSMPVfields,
  isSpreadMaintenance
} from "./loan-prepayment-schedule-logic";

export const rows = (index, isQuote, startSave, goBack) => ({
  title: {
    label: "Prepayment Schedule",
    isTitle: true,
    buttonLabel: "Remove",
    onTitleButtonClick: data => {
      const current = data.values;
      current.prepaymentSchedules = current.prepaymentSchedules.filter(x => x.id !== current.prepaymentSchedules[index].id);
      startSave(current, goBack);
    },
    titleButtonStyle: { color: "#C40A0A", float: "right" }
  },
  prepaymentType: {
    label: "Prepayment Type",
    cells:
        [
          {
            type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
            key: "prepaymentTypeId",
            name: `prepaymentSchedules[${index}].prepaymentTypeId`,
            variant: "filled",
            parentId: "prepaymentTypes",
            displayWith: option => option.name,
            setValueWith: option => option.id,
            onChange: value => {
              console.log("onChange", { value });
            }
          }
        ]
  },
  begin: {
    label: "Begin Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `prepaymentSchedules[${index}].begin`,
        variant: "filled",
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  end: {
    label: "End Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `prepaymentSchedules[${index}].end`,
        variant: "filled",
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  shouldUsePV: {
    isVisible: data => isSpreadMaintenance(data.prepaymentSchedules[index]),
    label: "Use present value in this calculation",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: `prepaymentSchedules[${index}].shouldUsePV`,
        label: "",
        hideLabel: true
      }
    ]
  },
  term: {
    isVisible: data => shouldShowTerm(data, isQuote),
    label: "Term",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `prepaymentSchedules[${index}].term`,
        variant: "filled",
        decimals: 0
      }
    ]
  },
  percent: {
    isVisible: data => shouldShowPercent(data.prepaymentSchedules[index]),
    label: "Minimum Prepayment (%)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `prepaymentSchedules[${index}].percent`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  openPeriod: {
    isVisible: data => shouldShowOpenPeriod(data.prepaymentSchedules[index]),
    label: "Open Periods",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `prepaymentSchedules[${index}].openPeriod`,
        variant: "filled",
        decimals: 0
      }
    ]
  },
  replacementRateSpread: {
    isVisible: data => shouldShowForYmYmaMw(data.prepaymentSchedules[index]) || shouldShowSMPVfields(data.prepaymentSchedules[index]),
    label: "Replacement Rate Spread (bps)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `prepaymentSchedules[${index}].replacementRateSpread`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  lookback: {
    isVisible: data => shouldShowForYmYmaMw(data.prepaymentSchedules[index]) || shouldShowSMPVfields(data.prepaymentSchedules[index]),
    label: "Replacement Rate Lookback",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `prepaymentSchedules[${index}].lookbackDays`,
        variant: "filled"
      }
    ]
  },
  rounding: {
    isVisible: data => shouldShowForYmYmaMw(data.prepaymentSchedules[index]) || shouldShowSMPVfields(data.prepaymentSchedules[index]),
    label: "Replacement Rate Rounding",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: `prepaymentSchedules[${index}].roundingId`,
        variant: "filled",
        parentId: "roundingList",
        displayWith: option => option.name,
        setValueWith: option => option.value
      }
    ]
  },
  aggregateInterestMethodId: {
    isVisible: data => shouldShowAggregateInterestMethodId(data.prepaymentSchedules[index]),
    label: "Aggregate Interest Method",
    cells:
        [
          {
            type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
            key: "aggregateInterestMethodId",
            name: `prepaymentSchedules[${index}].aggregateInterestMethodId`,
            variant: "filled",
            options: [
              { name: "Defined", id: "998e6888-830c-11e9-a53c-0242ac120002" },
              { name: "Formulaic", id: "9cdef848-830c-11e9-a53c-0242ac120002" }
            ],
            displayWith: option => option.name,
            setValueWith: option => option.id,
            onChange: value => {
              console.log("onChange", { value });
            }
          }
        ]
  },

  aggregateInterestDefinedAmt: {
    isVisible: data => shouldShowAggregateInterestDefinedAmt(data.prepaymentSchedules[index]),
    label: "Prepayment Amount",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: `prepaymentSchedules[${index}].aggregateInterestDefinedAmt`,
        variant: "filled",
        decimals: 0
      }
    ]
  },
  aggregateInterestMonthsOfInterest: {
    isVisible: data => shouldShowAggregateInterestMonthsOfInterest(data.prepaymentSchedules[index]),
    label: "Months of Interest",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `prepaymentSchedules[${index}].aggregateInterestMonthsOfInterest`,
        variant: "filled",
        decimals: 0
      }
    ]
  }
});
